import Category from '../core/types/category.type';
import ILog, { LogLevel } from '../core/types/log.type';
import IMessage, { IShared } from '../core/types/message.type';
import postXHR from '../util/xhr';

let EVENT_FLAG: boolean = true;
let sharedData: IShared[] = [];

function EventMiddleware(ctx: any, next: any): any {

    function eventMethodFactory(category: Category) {
        return (name: string, padding?: object) => {
            ctx.core.emit(LogLevel.INFO);
            ctx.core.beat();
            const cache: ILog[] = [];
            const mergedData: IMessage[] = [];
            cache.push({
                name,
                content: '',
                level: LogLevel.INFO,
                padding: padding || {},
                resourceUrl: '',
            });
            cache.forEach((e: ILog, i: number) => {
                mergedData.push(Object.assign(ctx.inspect(), { log: e }, { category }));
            });

            const postData = [{
                common: sharedData,
                body: mergedData,
            }];

            postXHR({
                data: encodeURIComponent(JSON.stringify(postData)),
            });
        };
    }

    if (EVENT_FLAG) {
        sharedData = ctx.getShared();
        EVENT_FLAG = false;
        ctx.core.moduleClick = eventMethodFactory(Category.MODULE_CLICK);
        ctx.core.moduleView = eventMethodFactory(Category.MODULE_VIEW);
        ctx.core.moduleEdit = eventMethodFactory(Category.MODULE_EDIT);
    }

    next();
}

export default EventMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/event-middleware.ts